import React, { Component } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import { Spinner } from 'react-activity';
import { customStyles } from '../../../../utils/Utility';

class SessionReferral extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEducatorId: '',
            educatorOptions: [],
        };
    }

    //componentDidMount
    componentDidMount() {
        this.prepareEducatorOptions();
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        if (prevProps.educatorList !== this.props.educatorList) {
            this.prepareEducatorOptions();
        }
    }

    //prepareEducatorOptions
    prepareEducatorOptions = () => {
        const educatorOptions = this.props.educatorList.map((educator) => ({
            value: educator.id,
            label: educator.name,
        }));
        this.setState({ educatorOptions });
    };

    //handleEducatorChange
    handleEducatorChange = (selectedOption) => {
        this.setState({
            selectedEducatorId: selectedOption ? selectedOption.value : '',
        });
    };

    //resetState
    resetState = () => {
        this.setState({
            selectedEducatorId: '',
        });
    };

    //customOptionLabel
    customOptionLabel = ({ label }) => (
        <div className="overflow-hidden truncate" title={label}>
            {label}
        </div>
    );

    render() {
        const {
            openModal,
            closeModal,
            onChange,
            submitCancelation,
            btnLoading,
            isEducatorLoading,
        } = this.props;
        const { selectedEducatorId, educatorOptions } = this.state;

        return (
            <Modal
                isOpen={openModal}
                onRequestClose={() => {
                    closeModal();
                    this.resetState();
                }}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-collaboratortable">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-white">
                                Create Referral
                            </h3>
                            <button
                                type="button"
                                onClick={() => {
                                    this.props.closeModal();
                                    this.resetState();
                                }}
                            >
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div>
                            <div>
                                <label
                                    htmlFor="select-educator"
                                    className="block mb-2 text-base font-normal text-white mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                >
                                    Select Owner
                                </label>
                                <Select
                                    isLoading={isEducatorLoading}
                                    id="educator"
                                    name="educator"
                                    className="block rounded whitespace-nowrap text-secondary text-md border-black-10 referral-educator"
                                    styles={customStyles}
                                    options={educatorOptions}
                                    placeholder="Search and select by Owner name"
                                    onChange={this.handleEducatorChange}
                                    formatOptionLabel={this.customOptionLabel}
                                    onKeyDown={(event) => {
                                        const key = event.key;
                                        const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                        if (
                                            !allowedCharacters.test(key) ||
                                            (event.keyCode === 32 &&
                                                !this.selectRef.state.inputValue)
                                        ) {
                                            event.preventDefault();
                                        }
                                    }}
                                    value={educatorOptions.find(
                                        (option) => option.value === selectedEducatorId
                                    )}
                                    ref={(r) => (this.selectRef = r)}
                                />
                            </div>
                            <label
                                htmlFor="notesSummary"
                                className="block mt-6 mb-2 text-base font-normal text-white rounded "
                            >
                                Notes
                            </label>
                            <div className="py-1">
                                <textarea
                                    id="notesSummary"
                                    name="notesSummary"
                                    rows="3"
                                    onChange={onChange}
                                    placeholder="Summary can be added up to 500 characters"
                                    className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                    maxLength={500}
                                />
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                className="text-white border-black bg-black rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    this.props.closeModal();
                                    this.resetState();
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="text-white bg-UIprimary rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    submitCancelation(selectedEducatorId);
                                }}
                                disabled={btnLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {btnLoading ? <Spinner color="#FFF" /> : 'Save'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default SessionReferral;
